import { useState } from "react";
import { useSelector } from "react-redux";
import Song from "./song/song.js";
import useStyles from "./styles.js";

const Album = ({ album }) =>
{

  const displayImages = useSelector((state) => state.image_handler);
  const [selected, toggleSelected] = useState(false);
  const classes = useStyles();

  return (
    <div className={classes.cont}>

      {displayImages ?
        <img className={classes.img} src={album.cover} alt={album.album} onClick={() => toggleSelected(!selected)} />
        :
        <div onClick={() => toggleSelected(!selected)}>{album.album}</div>
      }
      {selected ?
        (
          <div className="songsContainer">
            {album.songs.map((song, song_index) => (
              <Song key={song._id} album_index={album.index} song={song} song_index={song_index} />
            ))}
          </div>
        )
        : <div />
      }
    </div>
  );
}

export default Album;